import * as React from 'react';

export function useGlobalAction () {
	const funnelAdress = '/bewerben/erfahrung';

	return React.useCallback(() => {
		window.open(funnelAdress, '_self')?.focus();
	}, []);
}
